/**
 * Google Consent Mode v2 helpers.
 * Initialisation lives in public/index.html; here we only update consent state.
 */

const CONSENT_KEY = "dvq_consent";

export function loadConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function saveConsent(state) {
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ ...state, ts: Date.now() }));
  } catch (e) {
    /* ignore */
  }
}

function toGranted(value) {
  return value ? "granted" : "denied";
}

/**
 * Push consent update to Google Consent Mode v2.
 * state: { analytics, marketing, functional }
 */
export function updateConsent(state) {
  if (typeof window === "undefined") return;
  const payload = {
    ad_storage: toGranted(state.marketing),
    ad_user_data: toGranted(state.marketing),
    ad_personalization: toGranted(state.marketing),
    analytics_storage: toGranted(state.analytics),
    functionality_storage: toGranted(state.functional),
    personalization_storage: toGranted(state.functional),
    security_storage: "granted",
  };
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", payload);
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "consent_update", consent: payload });
}
